module.exports = __webpack_public_path__ + "img/logo_ufrgs.325a438b.svg";